export const GLOBAL_PARAM_ID = -999999;
//# sourceMappingURL=types.js.map